// Image fade-in: img.z-fade starts transparent (assets/82zone-ui.css) and gets is-loaded once its bytes are in.
// Capturing listener so lazy images anywhere on the page are covered; images already complete are marked at once.
(() => {
  // Nothing else in the theme drops the no-js marker, so the fade (and any other JS-only styling) would stay off.
  document.documentElement.classList.remove('no-js');
  const mark = (img) => img.classList.add('is-loaded');
  const settle = (root) => {
    root.querySelectorAll('img.z-fade').forEach((img) => {
      if (img.complete) mark(img);
    });
  };
  document.addEventListener('load', (event) => {
    if (event.target instanceof HTMLImageElement && event.target.classList.contains('z-fade')) mark(event.target);
  }, true);
  document.addEventListener('error', (event) => {
    if (event.target instanceof HTMLImageElement && event.target.classList.contains('z-fade')) mark(event.target);
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => settle(document), { once: true });
  } else {
    settle(document);
  }
  // Sections re-rendered by the theme editor or by fetch (show more, filters) bring new images.
  new MutationObserver((records) => {
    records.forEach((r) => r.addedNodes.forEach((n) => n.nodeType === 1 && settle(n)));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
